<div class="dialog-container">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ title }}</h1>
    <button mat-icon-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSave()">
      @if (showDateField) {
        <app-date-picker
          [parentFormGroup]="form"
          controlName="date"
          label="Date"
          class="full-width"
        />
      }

      <app-text-input
        [parentFormGroup]="form"
        controlName="name"
        label="Holiday name"
        class="full-width"
      />

      <app-dropdown
        [parentFormGroup]="form"
        [options]="holidayTypeOptions"
        controlName="type"
        label="Type"
        class="full-width"
      />
    </form>
  </div>

  <div class="mat-dialog-actions">
    <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="form.invalid">Save</button>
  </div>
</div>
